// Replaced at compile time by webpack's DefinePlugin (and by vitest's define in
// tests), so it is the moment the loaded bundle was built.
export const appBuildTime = __BUILD_TIMESTAMP__
